export default __webpack_public_path__ + "static/media/1070.cd811851.png";